<template>
  <div>
    <b-table
        :fields="fields"
        :items="items"
        table-class="text-nowrap"
        responsive
        hover
    >
      <template #cell(shipper)="data">
        <h4 class="mb-0">
          <b-link :to="{name: 'admin-shipper', params: {id: data.item.shipper.id}}">
              {{ data.item.shipper.name }} - {{ data.item.shipper.license }}
          </b-link>
        </h4>
      </template>
      <template #cell(actions)="data">
        <no-permission-wrapper :show="!canUpdateShippers">
          <b-btn
              @click.prevent="() => onClickUpdatePrice(data.item.shipper_price)"
              variant="primary"
              :disabled="!canUpdateShippers"
          >
            Edit
          </b-btn>
        </no-permission-wrapper>
        <no-permission-wrapper :show="!canUpdateShippers">
          <b-btn
              @click.prevent="() => onClickDeletePrice(data.item.shipper_price)"
              variant="danger"
              :disabled="!canUpdateShippers"
          >
            Delete
          </b-btn>
        </no-permission-wrapper>
      </template>
    </b-table>
  </div>
</template>

<script>
import {getFormattedPrice, getFormattedStateName} from "../helpers";
import NoPermissionWrapper from "./NoPermissionWrapper.vue";

export default {
  name: "AdminShipperPricesTable",
  components: {NoPermissionWrapper},
  emits: ['update', 'delete'],
  props: {
    prices: {
      type: Array,
      required: true
    },
    noShipperCol: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    canUpdateShippers() {
      return this.$store.getters['auth/hasAdminPermissions']('shipper_update');
    },
    items() {
      return this.prices.map(price => {
        return {
          shipper_price: price,
          shipper: price.shipper,
          state: getFormattedStateName(price.destination_state),
          city: price.destination_city,
          price: getFormattedPrice(price.price)
        }
      });
    },
    fields() {
      let fields = [
        {
          key: "state",
          thClass: "border-top-0",
          tdClass: "align-middle"
        },
        {
          key: "city",
          thClass: "border-top-0",
          tdClass: "align-middle"
        },
        {
          key: "price",
          thClass: "border-top-0",
          tdClass: "align-middle"
        },
        {
          key: "actions",
          thClass: "border-top-0 width-0",
          tdClass: "align-middle"
        },
      ];
      if (!this.noShipperCol) {
        fields.unshift({
          key: "shipper",
          thClass: "border-top-0",
          tdClass: "align-middle"
        });
      }

      return fields;
    }
  },
  methods: {
    onClickUpdatePrice(shipperPrice) {
      this.$emit('update', shipperPrice);
    },
    onClickDeletePrice(shipperPrice) {
      this.$emit('delete', shipperPrice);
    }
  }
}
</script>
